import { useContext } from 'react';

import { useUtils } from '@ezbobdev/ui-commons';
import { MainContext } from '@ezbobdev/ui-framework';

import { ALERT_VARIANTS } from '../../utils/constants';

export const useAlerts = (props, widgetName) => {
  const { actions, view } = useContext(MainContext);
  const { alerts } = view;
  const { getConfig, configByName } = useUtils(props, widgetName);

  const alertVariant = getConfig('variant', ALERT_VARIANTS.alert);

  const successIcon = getConfig(`successIcon`, '');
  const errorIcon = getConfig(`errorIcon`, '');

  const closeAlertByType = (type) => {
    actions.view.setAlerts(alerts.filter((alert) => alert.type !== type));
  };

  const onClose = (index) => {
    actions.view.removeAlert(index);
  };

  return {
    ...props,
    alerts,
    alertVariant,
    configByName,
    successIcon,
    errorIcon,
    onClose,
    closeAlertByType,
  };
};
